<div class="ui basic segment" [class.loading]="isLoading">
    <app-steps
        [labels]="{ primary: 'surveys.store.sendSurvey' }"
        [options]="{
            useDisableNextFunctionality: true,
        }"
        #appSteps
        [steps]="[detailsStep, participantsStep, summaryStep]"
        action="Create"
        (onPrimary)="onSave()"
    >
        <app-step
            #detailsStep
            [stepForm]="detailsForm"
            step="surveys.store.newSurvey"
            title="surveys.store.createSurvey"
        >
            <app-form-survey-details
                #detailsForm
                [survey]="survey"
                (templatesLoaded)="summaryForm.onTemplatesLoaded($event)"
            ></app-form-survey-details>
        </app-step>

        <app-step
            #participantsStep
            [stepForm]="participantsForm"
            step="surveys.store.participants"
            title="surveys.store.selectParticipants"
        >
            <app-form-survey-participants
                #participantsForm
                [survey]="survey"
                [participants]="participants"
                (participantsChanged)="summaryForm.onParticipantsChanged()"
            ></app-form-survey-participants>
        </app-step>

        <app-step
            #summaryStep
            [stepForm]="summaryForm"
            step="surveys.store.summary"
            title="surveys.store.summaryAndSend"
        >
            <app-form-survey-summary
                #summaryForm
                [survey]="survey"
                [participants]="participants"
            ></app-form-survey-summary>
        </app-step>
    </app-steps>
</div>
